import { CloseOutlined } from '@ant-design/icons';
import { FishingReport, SeasonGroup, Species } from '@omniafishing/core';
import { Skeleton } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { MapRef } from 'react-map-gl';
import { useSelector } from 'react-redux';
import { useResponsive } from '../../../../hooks/use_responsive';
import { getSpeciesTop } from '../../../../redux/reference_data';
import { ActiveMapPageModalType } from '../../../../routes/map_page/lib/map_page_types';
import { PinHighActivity } from '../../pin_high_activity';
import { SpeciesSeasonFilters } from '../lakes_modal/species_season_filters';
import { FeaturedMapFishingReports } from './featured_map_fishing_reports';
import styles from './featured_reports_modal.less';
import { ModalNoReports } from './modal_no_reports';

interface FeaturedReportsModalProps {
  fishingReports: FishingReport[];
  fishingReportsCountTotal: number;
  fishingReportsSpecies: Species | null;
  fishingReportsSeasonGroup: SeasonGroup | null;
  fishingReportsLoading: boolean;
  fihsingReportsLoadingComplete: boolean;
  isModalOpen: boolean;
  loadMoreElementRef: (node: HTMLDivElement) => void;
  mapRef: MapRef;
  onClose: (modalType: ActiveMapPageModalType) => void;
  onSeasonGroupSelect: (seasonGroupName: string | null) => void;
  onSpeciesSelect: (speciesName: string | null) => void;
}

export const FeaturedReportsModal = (props: FeaturedReportsModalProps) => {
  const {
    fishingReports,
    fishingReportsCountTotal,
    fishingReportsLoading,
    fishingReportsSeasonGroup,
    fishingReportsSpecies,
    fihsingReportsLoadingComplete,
    isModalOpen,
    loadMoreElementRef,
    mapRef,
    onClose,
    onSeasonGroupSelect,
    onSpeciesSelect,
  } = props;

  const { isMobile } = useResponsive();
  const topSpecies = useSelector(getSpeciesTop);

  if (!isModalOpen) {
    return null;
  }

  return (
    <div className={classNames(styles.modal)}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <span className={styles.heading}>
            <span className={styles.pin}>
              <PinHighActivity favorite={false} featured />{' '}
            </span>
            <span>
              {fihsingReportsLoadingComplete && fishingReportsCountTotal === 0
                ? 'No Featured Fishing Reports Found'
                : `${
                    fihsingReportsLoadingComplete ? fishingReportsCountTotal : ''
                  } Featured Reports in this area`}
            </span>
          </span>
          <CloseOutlined onClick={() => onClose('featuredReports')} />
        </div>
        <div className="mb-3">
          <SpeciesSeasonFilters
            speciesOptions={topSpecies}
            selectedSeasonGroup={fishingReportsSeasonGroup}
            selectedSpecies={fishingReportsSpecies}
            onSeasonGroupSelect={onSeasonGroupSelect}
            onSpeciesSelect={onSpeciesSelect}
          />
        </div>
        <ul className={styles.reportList}>
          {fishingReportsLoading ? (
            Array.from({ length: 6 }, (__, i) => (
              <Skeleton active key={i} paragraph={{ rows: 4 }} />
            ))
          ) : fishingReports.length === 0 ? (
            <ModalNoReports
              mapRef={mapRef}
              onClick={() => {
                if (isMobile) {
                  onClose('featuredReports');
                }
              }}
            />
          ) : (
            <FeaturedMapFishingReports
              fishingReports={fishingReports}
              loadMoreElementRef={loadMoreElementRef}
            />
          )}
        </ul>
      </div>
    </div>
  );
};
